import { Link } from "react-router-dom";

import useDashboardProfile from "../hooks/useDashboardProfile";
import useDashboard from "../hooks/useDashboard";
import useNotifications from "../hooks/useNotifications";
import usePageTitle from "../hooks/usePageTitle";

import NotificationsIcon from "@mui/icons-material/Notifications";
import RamenDiningIcon from "@mui/icons-material/RamenDining";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import moment from "moment-timezone";

const Dashboard = () => {
  const [profile, error] = useDashboardProfile();
  const { myEvents, error: myEventsError } = useDashboard();
  const { notifications, error: notificationError } = useNotifications();

  const threeNotifications = notifications?.slice(0, 3);

  const myActiveEvents = myEvents?.filter((event) => {
    return event.active === true && moment(event.date).isAfter(moment());
  });

  const myNotActiveEvents = myEvents
    .filter((event) => {
      return moment(event.date).isBefore(moment()) || event.active === false;
    })
    .sort((event1, event2) => {
      if (moment(event1.date).isBefore(moment(event2.date))) {
        return 1;
      } else {
        return -1;
      }
    });

  usePageTitle(`Dashboard | Fudopia | Meet. Eat. Repeat.`);

  return (
    <>
      {error ||
        myEventsError ||
        (notificationError && <p>Something went wrong</p>)}
      <Typography variant="h1">Dashboard</Typography>
      {profile && (
        <>
          <p className="capitalize welcome">Hello {profile.username} 👋</p>
          <div className="button-wrapper">
            <Link to={`/dashboard/profile`}>
              <Button color="primary" variant="contained">
                See My Profile
              </Button>
            </Link>
          </div>
        </>
      )}
      <div className="section">
        <Typography variant="h2" component="div">
          <NotificationsIcon fontSize="small" className="icon-header" />{" "}
          Notifications
        </Typography>
        <div className="block-wrapper">
          {!notifications?.length && (
            <Typography variant="p" component="div" sx={{ flexGrow: 0 }}>
              You don't have any yet.
            </Typography>
          )}
          {threeNotifications?.map((notification, key) => (
            <div key={key} className="thin-block">
              {/* TODO: remove it later */}
              {notification.event_id ? (
                <Link to={`/events/${notification.event_id}`}>
                  <p style={{ fontWeight: 600, marginBottom: 8 }}>
                    {notification.subject}
                  </p>
                  <p style={{ marginTop: 0 }}>{notification.body}</p>
                </Link>
              ) : (
                <p>{notification.body}</p>
              )}
            </div>
          ))}
          {notifications.length > 3 && (
            <div className="button-wrapper">
              <Button color="primary" variant="contained">
                <Link to="notifications">See all notifications</Link>
              </Button>
            </div>
          )}
        </div>
      </div>
      <div className="section">
        <Typography variant="h2">
          <RamenDiningIcon fontSize="small" className="icon-header" />
          My Upcoming Events
        </Typography>
        <div className="block-wrapper events db">
          {!myActiveEvents.length && (
            <>
              <div className="sm-section">
                <p>
                  You have no events at the moment. <br />
                  You can create your own event by selecting a dish to try
                  first.
                </p>
                <Link to="/dishes">
                  <Button color="primary" variant="contained">
                    Create an event
                  </Button>
                </Link>
              </div>
              <div className="sm-section">
                <p> Join an existing event</p>
                <Link to="/events">
                  <Button color="secondary" variant="contained">
                    See events
                  </Button>
                </Link>
              </div>
            </>
          )}
          {myActiveEvents?.map((event) => (
            <div key={event.id} className="block">
              {event.author.id === profile.id && (
                <p className="author">You created this event ✍️</p>
              )}
              <Link to={`/events/${event.id}`}>
                <h3>{event.title}</h3>
              </Link>
              <p>{event.city?.title}</p>
              <span>
                {moment(event.date)
                  .tz(event.timezone)
                  .format("dddd, MMMM Do · h:mm a")}
              </span>
            </div>
          ))}
        </div>
        <div className="section">
          <Typography variant="h2" component="div">
            <RamenDiningIcon fontSize="small" className="icon-header" />
            Past or Cancelled Events
          </Typography>
          <div className="block-wrapper events db">
            {!myNotActiveEvents.length && (
              <Typography variant="p" component="div" sx={{ flexGrow: 0 }}>
                You don't have any yet.
              </Typography>
            )}
            {myNotActiveEvents?.map((event) => (
              <div key={event.id} className="inactive block">
                {event.author.id === profile.id && (
                  <p className="author">You created this event ✍️</p>
                )}
                {event.active === false && <p>Cancelled Event</p>}
                <Link to={`/events/${event.id}`}>
                  <h3>{event.title}</h3>
                </Link>
                <p>{event.city?.title}</p>
                <p>{moment(event.date).format("dddd, MMMM Do · h:mm a")}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
